<template>
	<div>
		<label>
			<input
				type="search"
				:value="search"
				@input="onSearchChange"
				placeholder="Search"
			>
		</label>
	</div>
</template>

<script>
import debounce from 'debounce'

export default {
	name: "UserTableSearch",
	data() {
		return {
			search: ''
		}
	},
	methods: {
		onSearchChange: debounce(function (e) {
			this.search = e.target.value
			this.$emit('onSearchChange', this.search)
		}, 150)
	}
}
</script>

<style scoped lang="scss">

input {
	box-sizing: border-box;
	display: block;
	padding: 10px;
	background-color: #fff;
	border: none;
	color: black;
	border-radius: 6px;
	width: 100%;
	margin: 0 auto 10px;

	&:focus {
		outline: none;
	}
}

</style>